export default function formatCentsToCurrency(cents, currency = 'EUR', round = false) {
  const value = cents / 100;
  const locale = currency === 'USD' ? 'en-US' : 'es-ES';

  let finalValue = round ?  Math.ceil(value) : value;
  const formatOptions = {
    currency,
    style: 'currency',
  }
  if (round) {
    finalValue = Math.ceil(finalValue);
    formatOptions.minimumFractionDigits = 0;
    formatOptions.maximumFractionDigits = 0;
  }

  const formatter = Intl.NumberFormat(locale, formatOptions);
  return formatter.format(finalValue);
}
